import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let policyListPageMachine: any;

export const useSMPolicyListPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  policyListPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(policyListPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    policyListPageMachine,
    policyListPageState: state,
    policyListPageSend: send,
  };
};
